import { render, staticRenderFns } from "./LoginAluno.vue?vue&type=template&id=427c571c&scoped=true"
import script from "./LoginAluno.vue?vue&type=script&lang=js"
export * from "./LoginAluno.vue?vue&type=script&lang=js"
import style0 from "./LoginAluno.vue?vue&type=style&index=0&id=427c571c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427c571c",
  null
  
)

export default component.exports